module.exports = __webpack_public_path__ + "static/media/plus-circled.b851d67c.svg";